import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component'; // leaf import - do not revert to the barrel (app/shared/infrastructure), breaks ng test (circular dependency)
import { environment } from 'environments/environment';

@Injectable()
export class AggregatorPatientService extends ServiceBase {

    constructor(private _http: HttpClient) {
        super();
    }

    checkExpireDocuments = (id: number, isRaise: boolean): Observable<any> => {
        return this._http.get<any>(`${environment.httpAggregatorApi}Patient/CheckExpireDocuments?PatientId=${id}&IsRaise=${isRaise}`)
    }

    CheckEligibility = (object): Observable<any> => {
        const data = {
            "payerId": object.payerId,
            "documentNumber": object.documentNumber,
            "documentType": object.documentType,
            "purposeIds": object.purposeIds,
            "contractId": object.contractId,
            "fromDate": object.fromDate.toLocaleDateString(),
            "toDate": object.toDate != null ? object.toDate.toLocaleDateString() : null,
        };

        return this._http.post<any>(`${environment.httpAggregatorApi}Patient/CheckEligibilityByDocument`, JSON.stringify(data));
    }

    CheckEligibilityByPatient = (data): Observable<any> => {
        data.fromDate = data.fromDate.toLocaleDateString();
        
        return this._http.post<any>(`${environment.httpAggregatorApi}Patient/CheckEligibilityByPatientId`, JSON.stringify(data));
    }

    CheckPatientEligibility = (data): Observable<any> => {
        return this._http.post<any>(`${environment.httpAggregatorApi}Patient/CheckPatientEligibility`, JSON.stringify(data));
    }

    SetEligibilityVisitInfo = (data): Observable<any> => {
        return this._http.put<any>(`${environment.httpAggregatorApi}Patient/SetEligibilityVisitInfo`, JSON.stringify(data));
    }
}